
import { tr } from '../translate'
import Close from '@/assets/icons/fontawesome/light/times.svg?inline'
import Lock from '@/assets/icons/support_ticket/lock.svg?inline'
import Paperclip from '@/assets/icons/support_ticket/paperclip.svg?inline'

export default {
  components: { Close, Lock, Paperclip },
  props: {
    config: {
      type: Object,
      default: null,
    },
    category: {
      type: Object,
      default: null,
    },
    subcategory: {
      type: Object,
      default: null,
    },
    orderNum: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    file: {
      // Browser File object; left untyped since `File` isn't defined during SSR.
      type: null,
      default: null,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ui() {
      return this.config?.ui
    },
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
    onFileChange(e) {
      const picked = e.target.files?.[0]
      e.target.value = ''
      if (!picked) {
        return
      }
      this.$emit('update:file', picked)
    },
  },
}
